import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import InvoicesContainer from './invoices/list/InvoicesContainer';
const invoicesErb = document.getElementById('invoices-container');

if (invoicesErb != null) {
  const root = createRoot(invoicesErb);
  const accountId = window.currentAccountId;

  root.render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <InvoicesContainer accountId={accountId} />
    </ThemeProvider>
  );
}

